import { RegionsPage as RegionsPageComponent } from '../components/RegionsPage';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';

export function RegionsPage() {
  return (
    <ErrorBoundary>
      <RegionsPageComponent />
    </ErrorBoundary>
  );
}
